import { render, staticRenderFns } from "./iconGender.vue?vue&type=template&id=4ec05dac"
import script from "./iconGender.vue?vue&type=script&lang=js"
export * from "./iconGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports